import {FC} from 'react'

import {ContentCard, ContentCardImageSize} from '@/components/common/content/ContentCard'
import {Text, TextVariant} from '@/components/common/content/Text'
import {getQuestionsAndAnswersContent} from '@/content/questionsAndAnswers'
import {useTranslation} from '@/i18n'
import {QuestionsAndAnswersContentType} from '@/utils/questions-and-answers/constants'

import {CardListLayout} from '../common/cards/CardListLayout'
import {CardWrapper} from '../common/cards/CardWrapper'

type QuestionsAndAnswersResourcesProps = {
  type: QuestionsAndAnswersContentType
}

export const QuestionsAndAnswersResources: FC<QuestionsAndAnswersResourcesProps> = ({type}) => {
  const {t} = useTranslation('page')
  const {title, list} = getQuestionsAndAnswersContent(type).resources

  return (
    <>
      <Text variant={TextVariant.h2} align="center">
        {t(title)}
      </Text>
      <CardListLayout isCentered={false}>
        {list.map(({imageSrc, imageAlt, title, description, linkHref}) => (
          <CardWrapper key={title} numOfCardsPerRow={4}>
            <ContentCard
              title={t(title)}
              titleTextVariant={TextVariant.h5}
              imageSrc={imageSrc}
              imageAlt={imageAlt}
              imageSize={ContentCardImageSize.large}
              description={t(description)}
              linkHref={linkHref}
              trackedEvent={{
                name: 'Q&A resource is clicked',
                parameters: {resource: t(title)},
              }}
            />
          </CardWrapper>
        ))}
      </CardListLayout>
    </>
  )
}
